// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-x-checklist-checkbox{position:absolute;left:-2666.64rem}.v5-x-checklist-checkbox:checked+*{color:#ff552e}", ""]);
// Exports
module.exports = exports;
